import { getFeatureFlag } from "@/shared/lib/analytics";

/** SA-1160: chave da feature flag do PostHog que aloca a variante do onboarding. */
export const ONBOARDING_VARIANT_FLAG = "onboarding-with-card";

export type OnboardingVariant = "with_card" | "without_card";

/**
 * SA-1160: resolve a variante do experimento de onboarding a partir da feature
 * flag do PostHog. `without_card` é o controle e também o fallback quando a
 * flag ainda não carregou (analytics não inicializado / flags em voo).
 */
export function resolveOnboardingVariant(): OnboardingVariant {
  return getFeatureFlag(ONBOARDING_VARIANT_FLAG) === "with_card"
    ? "with_card"
    : "without_card";
}
